import { ModalType } from 'constants/modal';
import { useCallback, useEffect } from 'react';
import { ModalHandler } from 'utils/ModalHandler';
import { useAnswerNpsCampaignMutation } from 'queries/nps/useAnswerNpsCampaignMutation';
import { useGetNpsCampaignAnswerQuery } from 'queries/nps/useGetNpsCampaignAnswerQuery';
import { useGetNpsCampaignQuery } from 'queries/nps/useGetNpsCampaignQuery';
import { LocalStorage } from 'utils/LocalStorage';
import { LocalStorageKey } from '@diritto/common/utils/localStorage';
import { useAuthState } from 'contexts/AuthProvider';

export const useShowNpsCampaignModal = () => {
  const { user } = useAuthState();

  // 서버로 가는 req 를 줄이기 위해 localStorage 에서 먼저 확인한다.
  const npsCampaignAnsweredId = LocalStorage.getItem(LocalStorageKey.NpsCampaignAnsweredId);

  // npsCampaign 정보를 가져온다.
  const { data: npsCampaignData, isFetched: isNpsCampaignFetched } = useGetNpsCampaignQuery();
  const npsCampaignId = npsCampaignData?.npsCampaign?.id;

  // LocalStorage 에 기존에 답한 적 있는 캠패인인지 확인한다.
  const isMatchNpsCampaignAnswerId = String(npsCampaignAnsweredId) === String(npsCampaignId);

  // 유저가 해당 캠페인에 응답을 했는지 서버에 가서 확인한다.
  const { data: npsCampaignAnswerData, isFetched: isNpsCampaignAnswerFetched } = useGetNpsCampaignAnswerQuery(
    npsCampaignId,
    !!npsCampaignId && !isMatchNpsCampaignAnswerId,
  );

  const { mutateAsync } = useAnswerNpsCampaignMutation(npsCampaignId);

  const markAnswer = useCallback(() => {
    LocalStorage.setItem(LocalStorageKey.NpsCampaignAnsweredId, String(npsCampaignId));
  }, [npsCampaignId]);

  // 이미 답변한 적이 있으면 LocalStorage 에 값을 저장한다.
  useEffect(() => {
    if (npsCampaignAnswerData?.isAnswered) {
      markAnswer();
    }
  }, [markAnswer, npsCampaignAnswerData]);

  return {
    isPrepared: isNpsCampaignFetched && (!npsCampaignId || isMatchNpsCampaignAnswerId || isNpsCampaignAnswerFetched),
    needShowNpsCampaignModal: !!(
      user &&
      npsCampaignId &&
      !(isMatchNpsCampaignAnswerId || npsCampaignAnswerData?.isAnswered)
    ),
    showNpsCampaignModal: useCallback(() => {
      if (!npsCampaignData?.npsCampaign) {
        return;
      }

      ModalHandler.show(ModalType.NpsCampaign, {
        npsCampaign: npsCampaignData.npsCampaign,
        onSubmit: payload => {
          markAnswer();
          mutateAsync(payload);
        },
        onCancel: () => {
          markAnswer();
          mutateAsync({});
        },
      });
    }, [npsCampaignData, markAnswer, mutateAsync]),
  };
};
